import React from "react";

import { AddEmployees, PartnerAddEmployees } from "EmployerApplication/Components";
import { RESOURCE_STATES } from "EmployerApplication/Reducers";
import { connect } from "react-redux";
import getTooltip from "Utils/getTooltip";
import { BasicLoading } from "ZeroRuby";

import { SurfaceSection } from "Cobalt/Surface";
import AgentHeader from "Common/Agent/AgentHeader";
import InfoPopover from "Common/InfoPopover";
import { usePartnerContext } from "Common/PartnerContext";
import { Surface, SurfaceHeader } from "Theme/Surface";

export const AddEmployeesPage = ({ isLoading }) => {
  const { partnerContextEnabled } = usePartnerContext();

  return (
    <Surface>
      <SurfaceHeader>Manage Employees</SurfaceHeader>
      <SurfaceSection>
        <AgentHeader>
          Now, let's add your employees. Each&nbsp;
          <InfoPopover
            infoTitle="Leigh Says..."
            infoText={getTooltip("Eligible Employee")}
            className="AddEmployees__toolTip"
            displayComponent={<span className="AddEmployees__toolTipDisplay">eligible employee</span>}
            placement="top"
          />
          &nbsp;needs to either apply for coverage or fill out a waiver.
        </AgentHeader>
      </SurfaceSection>
      {isLoading ? <BasicLoading /> : partnerContextEnabled ? <PartnerAddEmployees /> : <AddEmployees />}
    </Surface>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.resourceStates?.companyProfile === RESOURCE_STATES.LOADING || state.resourceStates?.employees === RESOURCE_STATES.LOADING,
});

export default connect(mapStateToProps)(AddEmployeesPage);
